// extracted by mini-css-extract-plugin
module.exports = {"briefViewer":"BriefViewer_briefViewer__SErEY"};